/*
  Fix: blank (white) cart drawer on the first add-to-cart.

  The <cart-drawer> element is rendered with an "is-empty" class whenever the
  cart is empty at page load. When an item is then added over AJAX, the theme's
  renderContents() only replaces the markup INSIDE #CartDrawer -- the class lives
  on the <cart-drawer> element itself, one level up, so it is never cleared.
  The stale "is-empty" class collapses the drawer body to 0px height, so the
  drawer opens as an empty white panel (a right-hand strip on desktop, and the
  entire screen on mobile, where the drawer is full width).

  This keeps the class in sync with what the drawer actually contains.
*/
(function () {
  function syncEmptyState(drawer) {
    if (!drawer || !drawer.classList) return;
    var hasItems = !!drawer.querySelector('.cart-item');
    var hasEmptyMarkup = !!drawer.querySelector('.drawer__inner-empty');
    if (hasItems && !hasEmptyMarkup) {
      drawer.classList.remove('is-empty');
    } else if (!hasItems && hasEmptyMarkup) {
      drawer.classList.add('is-empty');
    }
  }

  function patch() {
    var el = document.querySelector('cart-drawer');
    if (!el) return;
    var proto = Object.getPrototypeOf(el);
    if (!proto || proto.__isEmptySyncPatched) return;
    if (typeof proto.renderContents !== 'function') return;

    var original = proto.renderContents;
    proto.renderContents = function () {
      var result = original.apply(this, arguments);
      var self = this;
      try {
        syncEmptyState(self);
        setTimeout(function () { syncEmptyState(self); }, 50);
      } catch (e) {}
      return result;
    };
    proto.__isEmptySyncPatched = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patch);
  } else {
    patch();
  }
  setTimeout(patch, 1000);
})();
